export const PACKAGE_TYPE_MADE = 0
export const PACKAGE_TYPE_AI = 1
export const PACKAGE_TYPE_OTHER = -1

class StaticType {
  titleIdx
  titleLen
  guidIdx
  guidLen
  type
  typeName

  constructor (type, typeName, tIdx, tLen, gIdx, gLen) {
    this.titleIdx = tIdx
    this.titleLen = tLen
    this.guidIdx = gIdx
    this.guidLen = gLen
    this.type = type
    this.typeName = typeName
  }
}

function getStaticType (tIdx, tLen, gIdx, gLen) {
  return function (type, typeName) {
    return new StaticType(type, typeName, tIdx, tLen, gIdx, gLen)
  }
}

const staticType1 = getStaticType(0, 100, 200, 50)
const staticType2 = getStaticType(0, 60, 63, 32)
const packageFileStaticType = {
  'DEFAULT': staticType1('DEFAULT', '默认点读包'),
  'D': staticType1('D', '自制点读包'),
  'F': staticType1('F', '自制扩展包'),
  'S': staticType1('S', '智能点读包'),
  'O': staticType1('O', '故事点读包'),
  'E': staticType2('E', '自制点读包'),
  'T': staticType2('T', '智能点读包'),
  'C': staticType2('C', '教辅点读包'),
}
export const FILE = 0
export const DIR = 1
export const SUFFIX_DAB = 'dab'
export const SUFFIX_DAR = 'dar'
export const SUFFIX_DAE = 'dae'
export const SUFFIX_DAS = 'das'
export const SUFFIX_DSR = 'dsr'
export const SUFFIX_DCS = 'dcs'
export const SUFFIX_OTHER = 'other'
export const hooks = ['readBeforeThreeBit', 'readTitle', 'readGuid', 'complate']

const THREE_BIT_UNB = 'UNB'
const THREE_BIT_DEB = 'DEB'
const THREE_BIT_DCB = 'DCB'
const THREE_BIT_ATT = 'ATT'

function noop () {

}

export default function PackageFile (type, fileName, dir) {
  let self = this
  self.isPackageFile = true
  self.isATT = false
  self.title = ''
  self.titleBit = ''
  self.guid = ''
  self.type = type
  self.fileName = decodeURI(fileName)
  self.dir = dir
  self.path = dir + '/' + fileName
  self.secretStartIdx = 342
  self.secretEndIdx = 345
  self.secretStartLen = 1
  self.secretEndLen = 4

  self.secret2StartIdx = 343
  self.secret2StartLen = 1
  self.secret2EndIdx = 373
  self.secret2EndLen = 4
  self.oidIdx = 336
  self.oidLen = 2
  self.isUNB = false
  self.contentIdx = ''
  self.contentLen = ''
  self.xorIdx = ''
  self.xorLen = ''
  self.canBeInstall = false
  self.packageType = PACKAGE_TYPE_OTHER
  this._init()
}

PackageFile.prototype._init = function () {
  const self = this
  if (self.type === FILE) {
    self.setSuffix()
    self.hooks = {
      readBeforeThreeBit: null,
      readTitle: self.readTitle,
      readGuid: self.readGuid,
      readUNBBitCheckType: null,
      complate: self.complate
    }
    switch (self.suffix) {
      case SUFFIX_DAR:
        self.staticType = [packageFileStaticType.D, packageFileStaticType.E]
        self.setMadeInOneSelf(PACKAGE_TYPE_MADE)
        self.hooks.readBeforeThreeBit = self.judgeStaticType
        break
      case SUFFIX_DAS:
        self.staticType = [packageFileStaticType.S, packageFileStaticType.T]
        self.setMadeInOneSelf(PACKAGE_TYPE_AI)
        self.hooks.readBeforeThreeBit = self.judgeStaticType
        break
      case SUFFIX_DAE:
        // 确定为F类型
        self.staticType = packageFileStaticType.F
        self.setMadeInOneSelf(PACKAGE_TYPE_MADE)
        break
      case SUFFIX_DSR:
        // 确定为O类型
        self.staticType = packageFileStaticType.O
        break
      case SUFFIX_DCS:
        // 确定为C
        self.staticType = packageFileStaticType.C
        break
      case SUFFIX_DAB:
        // 确定为 default
        // self.staticType = packageFileStaticType.DEFAULT
        self.staticType = [packageFileStaticType.D, packageFileStaticType.E, packageFileStaticType.S, packageFileStaticType.T]
        self.canBeInstall = true
        self.hooks.readBeforeThreeBit = self.judgeStaticType
        break
      default:
        // SUFFIX_OTHER
        self.isPackageFile = false
        self.staticType = null
        self.hooks = {
          readBeforeThreeBit: null,
          readTitle: null,
          readGuid: null,
          complate: null
        }
        break

    }
  }
}
PackageFile.prototype.setSuffix = function () {
  const self = this
  let fileName = self.fileName
  let pointIdx = fileName.lastIndexOf('.')
  if (pointIdx !== -1) {
    let number = fileName.substr(0, pointIdx)
    let suffix = fileName.substr(pointIdx + 1)
    self.number = number
    self.suffix = suffix.toLowerCase()
  } else {
    self.number = fileName
    self.suffix = ''
  }
}
PackageFile.prototype.judgeStaticType = function (threeBit) {
  const self = this
  threeBit = threeBit.toUpperCase()
  switch (threeBit) {
    case THREE_BIT_UNB:
      self.staticType = self.staticType.filter((staticType) => staticType.type === 'E' || staticType.type === 'T')
      if (self.staticType.length === 1) {
        self.staticType = self.staticType[0]
      } else {
        self.hooks.readUNBBitCheckType = self.readUNBBitCheckType
      }
      self.secretStartIdx = 149
      self.secretEndIdx = 150
      self.isUNB = true
      break
    case THREE_BIT_DEB:
      self.staticType = packageFileStaticType.S
      self.setMadeInOneSelf(PACKAGE_TYPE_AI)
      break
    case THREE_BIT_ATT:
      self.isATT = true
      break
    default:
      self.staticType = packageFileStaticType.D
      self.setMadeInOneSelf(PACKAGE_TYPE_MADE)
      break
  }
}
PackageFile.prototype.readTitle = function (title) {
  const self = this
  self.titleBit = title
  self.title = title.trim().replace(/^deb3/, '').replace(/^UNB/, '')
}
PackageFile.prototype.readGuid = function (guid) {
  const self = this
  self.guid = guid.replace(/^\{/g, '').replace(/\}$/g, '')
}
PackageFile.prototype.readUNBBitCheckType = function (bit) {
  const self = this
  const isMadeInOneSelf = bit === '0000'
  self.setMadeInOneSelf(isMadeInOneSelf ? PACKAGE_TYPE_MADE : PACKAGE_TYPE_AI)
  self.staticType = isMadeInOneSelf ? packageFileStaticType.E : packageFileStaticType.T
}
PackageFile.prototype.setMadeInOneSelf = function (packageType = PACKAGE_TYPE_OTHER) {
  this.packageType = packageType
  if (packageType === PACKAGE_TYPE_MADE) {
    this.contentIdx = 379
    this.contentLen = 4
    if (this.isUNB) {
      this.xorIdx = 161
      this.xorLen = 2
      this.contentIdx = 141
      this.contentLen = 2
    }
  }
}
PackageFile.prototype.complate = function () {
  return this
}
